<template>
  <div>
    <div class="bg-blue-900 p-4 sm:p-12">
      <div class="max-w-7xl mx-auto">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-white sm:text-3xl sm:truncate">
              Pipeline settings
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="sm:p-12">
      <div class="max-w-7xl mx-auto">
        <div v-if="rejected" class="rounded-md bg-red-50 p-4">
          <div class="flex">
            <div class="flex-shrink-0">
              <svg
                class="h-5 w-5 text-red-400"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414
                  1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293
                  1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0
                  00-1.414-1.414L10 8.586 8.707 7.293z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
            <div class="ml-3">
              <h3 class="text-sm font-medium text-red-800">
                Something went wrong. Please try again.
              </h3>
            </div>
          </div>
        </div>

        <div v-else-if="!loading" class="space-y-8">
          <PipelineUpdateForm :pipeline="pipeline" />

          <CoverForm :pipeline="pipeline" />

          <PipelineStagesUpdateForm :pipeline-id="pipeline.id" :pipeline-stages="pipelineStages" />

          <BaseCard>
            <BaseCardHeader>
              <div>
                <h3 class="text-lg leading-6 font-medium text-gray-900">Delete pipeline</h3>
                <p class="max-w-2xl text-sm text-gray-500">Permantly delete this pipeline.</p>
              </div>
            </BaseCardHeader>
            <BaseCardBody>
              <p class="text-gray-800 measure">
                Once a pipeline is deleted, all contacts associated with it will be detached.
              </p>
            </BaseCardBody>
            <BaseCardFooter gray>
              <PipelineDestroyForm :pipeline-id="pipeline.id" @destroyed="handleDestroyed" />
            </BaseCardFooter>
          </BaseCard>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PipelineUpdateForm from 'Forms/Pipeline/PipelineUpdateForm.vue';
import PipelineStagesUpdateForm from 'Forms/Pipeline/PipelineStagesUpdateForm.vue';
import PipelineDestroyForm from 'Forms/Pipeline/PipelineDestroyForm.vue';
import CoverForm from 'Forms/Pipeline/CoverForm.vue';

const components = {
  PipelineUpdateForm,
  PipelineStagesUpdateForm,
  PipelineDestroyForm,
  CoverForm,
};

const props = {
  pipelineId: {
    type: String,
    required: true,
  },
};

function data() {
  return {
    loading: false,
    rejected: false,
  };
}

const computed = {
  pipeline() {
    const {
      state: { entities, admin },
    } = this.$store;

    return entities.pipelines.byId[admin.pipelines.current];
  },
  pipelineStages() {
    const {
      state: { entities },
    } = this.$store;
    const { pipelineStages: pipelineStageIds = [] } = this.pipeline || {};

    return pipelineStageIds.map((id) => entities.pipelineStages.byId[id]).filter((p) => p);
  },
};

const methods = {
  setLoading(value) {
    this.loading = Boolean(value);
  },
  setRejected(value) {
    this.rejected = Boolean(value);
  },
  async fetchPipeline() {
    try {
      this.setLoading(true);

      await this.$store.dispatch('admin/pipelines/read', {
        id: this.pipelineId,
        params: {
          include: 'cover,pipelineStages',
        },
      });
    } catch (error) {
      this.setRejected(true);
    } finally {
      this.setLoading(false);
    }
  },
  handleDestroyed() {
    this.$router.replace({
      name: 'admin.pipelines',
    });
  },
};

function created() {
  this.fetchPipeline();
}

function destroyed() {
  const { commit } = this.$store;

  commit('admin/pipelines/setCurrent', null);
}

export default {
  components,
  props,
  data,
  computed,
  methods,
  created,
  destroyed,
};
</script>
